import React, { useEffect } from 'react';
import { useInfiniteHits } from 'react-instantsearch-hooks-web';
import { useInView } from 'react-intersection-observer';
import { useMediaQuery } from 'react-responsive';

export const InfiniteHits = (props) => {
  const { hitComponent: Hit, className, mode, children, noResultsComponent } = props;
  const { hits, isLastPage, showMore } = useInfiniteHits(props);
  const isMobile = useMediaQuery({ query: '(max-width: 1299px)' });

  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
  });

  useEffect(() => {
    if (inView && !isLastPage) {
      showMore();
    }
  }, [inView]);

  return (
    <div className={className}>
      {hits.map((hit, index) => (
        <>
          <Hit key={`${hit.id}-${index}`} hit={hit} index={index} />
          {index === 3 && !isMobile && children}
        </>
      ))}
      {/* {mode !== 'landing' && Boolean(hits.length) && } */}
      <div ref={ref}>{inView && !isLastPage && 'Loading Products...'}</div>
      {!Boolean(hits.length) && noResultsComponent && <>{noResultsComponent}</>}
      {/* <button onClick={() => showMore()}>Show More</button> */}
    </div>
  );
};
